import { z } from "zod";

import { FindPersonContactMode } from "@signalist/shared-types";

import { CsvEnrichmentType } from "@/enum/csv-enrichment.enum";
import { ScrapeLevel } from "@/enum/job.enum";
import { EnrichmentType, UpdateType } from "@/enum/list.enum";

/** What the list wizard's Find person step saves on the list itself (moved out of list.ts). */
export const UpdateListDetailsSchema = z.object({
	id: z.number(),
	scrapeLevel: z.nativeEnum(ScrapeLevel).or(z.nativeEnum(ScrapeLevel)).optional(),
	entityType: z.nativeEnum(CsvEnrichmentType).optional(),
	enrichmentType: z.nativeEnum(EnrichmentType).nullable().optional(),
	/** "Use my contacts first" / "Find new people only", on the lists that find people (PREC-3899). */
	findPersonContactMode: z.nativeEnum(FindPersonContactMode).optional(),
	updateType: z.nativeEnum(UpdateType),
});

export type UpdateListDetails = z.infer<typeof UpdateListDetailsSchema>;
